import {createSlice} from '@reduxjs/toolkit'
import {
    checkAuthWithHeaderThunk,
    checkAuthWithCookieThunk,
    tgWebAppSignInThunk,
    sendPhoneOtpThunk,
    verifyPhoneOtpThunk,
} from "../actions/authActions";
import {
    getAccessTokenOrNullFromStorage,
    getRefreshTokenOrNullFromStorage
} from "../utils/functions";

const accessToken = getAccessTokenOrNullFromStorage()
const refreshToken = getRefreshTokenOrNullFromStorage()

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuth: false,
        user: null,
        accessToken,
        refreshToken,
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: {
        [tgWebAppSignInThunk.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [tgWebAppSignInThunk.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.isAuth = true
            state.user = payload.user
            state.accessToken = payload.access_token
            state.refreshToken = payload.refresh_token
        },
        [tgWebAppSignInThunk.rejected]: (state, {payload}) => {
            state.loading = false
            state.error = payload
        },

        [sendPhoneOtpThunk.rejected]: (state, {payload}) => {
            state.error = payload
        },

        [verifyPhoneOtpThunk.fulfilled]: (state, {payload}) => {
            state.isAuth = true
            state.user = payload.user
            state.accessToken = payload.access_token
        },
        [verifyPhoneOtpThunk.rejected]: (state, {payload}) => {
            state.error = payload
        },

        [checkAuthWithHeaderThunk.pending]: (state) => {
            state.loading = true
            state.isAuth = false
            state.user = null
            state.error = null
        },
        [checkAuthWithHeaderThunk.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.isAuth = true
            state.user = payload.user
            state.accessToken = payload.access_token
            state.refreshToken = payload.refresh_token
        },
        [checkAuthWithHeaderThunk.rejected]: (state, {payload}) => {
            state.loading = false
            state.error = payload
        },

        [checkAuthWithCookieThunk.pending]: (state) => {
            state.loading = true
            state.isAuth = false
            state.user = null
            state.error = null
        },
        [checkAuthWithCookieThunk.fulfilled]: (state, {payload}) => {
            state.loading = false
            state.isAuth = true
            state.user = payload.user
            state.accessToken = payload.access_token
        },
        [checkAuthWithCookieThunk.rejected]: (state, {payload}) => {
            state.loading = false
            state.error = payload
        },
    },
})

export default authSlice.reducer
